import { createFileRoute } from '@tanstack/react-router'
import { SystemScreen } from '@/features/system/routes/system-screen'

export const SYSTEM_TABS = [
  'overview',
  'features',
  'services',
  'change',
  'impersonation',
  'data',
  'api',
  'stack',
] as const

export type SystemTab = (typeof SYSTEM_TABS)[number]

export interface SystemSearch {
  tab?: SystemTab
  /** A service id: its Reconnect dialog is open (D-019). */
  reconnect?: string
}

/**
 * `?tab=change` opens a tab directly — the Sandbox banner links to one entry
 * in the change log this way (docs/ENVIRONMENTS.md). `?reconnect=railway`
 * opens that service's Reconnect, so ⌘K and a tour can. Anything else is
 * ignored.
 */
export const Route = createFileRoute('/settings/system')({
  validateSearch: (search: Record<string, unknown>): SystemSearch => ({
    ...(SYSTEM_TABS.includes(search.tab as SystemTab) ? { tab: search.tab as SystemTab } : {}),
    ...(typeof search.reconnect === 'string' && /^[a-z][a-z-]{1,39}$/.test(search.reconnect)
      ? { reconnect: search.reconnect }
      : {}),
  }),
  component: SystemScreen,
})
